import { render, staticRenderFns } from "./payMsg.vue?vue&type=template&id=e94080a2&scoped=true&"
import script from "./payMsg.vue?vue&type=script&lang=js&"
export * from "./payMsg.vue?vue&type=script&lang=js&"
import style0 from "./payMsg.vue?vue&type=style&index=0&id=e94080a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e94080a2",
  null
  
)

export default component.exports